namespace RioERP.Users {
    export interface SupportForm {
        DisplayName: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        MobilePhoneNumber: Serenity.StringEditor;
        UserRole: Serenity.EnumEditor;
    }

    export class SupportForm extends Serenity.PrefixedContext {
        static formKey = 'Users.Support';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SupportForm.init)  {
                SupportForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;

                Q.initFormType(SupportForm, [
                    'DisplayName', w0,
                    'Email', w0,
                    'MobilePhoneNumber', w0,
                    'UserRole', w1
                ]);
            }
        }
    }
}
